export default __webpack_public_path__ + "static/media/ossscreen12.0f44cd59.png";